import { CorbadoProvider } from '@corbado/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mountComponent(corbadoAppState, element, Component, componentOptions, telemetry) {
    const ComponentWithContext = ({ providerProps, componentProps, }) => {
        return (React.createElement(CorbadoProvider, { ...providerProps },
            React.createElement(Component, { ...componentProps })));
    };
    const root = createRoot(element);
    const corbadoProviderProps = {
        corbadoAppInstance: corbadoAppState.corbadoApp,
        telemetry,
        ...corbadoAppState.corbadoAppProps,
    };
    root.render(React.createElement(ComponentWithContext, { providerProps: corbadoProviderProps, componentProps: componentOptions }));
    return root;
}
export function unmountComponent(root) {
    root.unmount();
}
